import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {getRatingsColor} from '@stencil/hotels-utils/src/get-ratings-colors';
import ImageGalleryPopup from '../../SRP/ImageGalleryPopup/ImageGalleryPopup';
import Modal, {useModal} from '@stencil/hotels-modal-component';
import {PrimaryLink} from '../../../CommonStyleUtils/dwebCommon.styles';

//GA Events
import {pushga} from 'ga-utils';
import {gaConfig} from '@stencil/hotels-config';
const {DetailPageGAEvents} = gaConfig;

import {
  WrapperDiv,
  UserAvatarWrapperDiv,
  UserReviewOuterWrapperDiv,
  UserReviewWrapperDiv,
  UserDetailsAndRatingWrapperDiv,
  UserReviewImageListWrapperDiv,
  HotelierResponseWrapperDiv,
  RowWithMarginR10,
  StyledImage,
  UserNameStyle,
  StayedOnStyle,
  AskedByStyle,
  RatingTextStyle,
  UserReviewTextStyle,
  HotelierResponseContentStyle,
  HotelierNameTextStyle,
  HotelierResponseTextStyle,
  ViewAllWrapDiv,
  ViewAllText,
} from './UserReview.styles';
import UserAvatar from '../UserAvatar/UserAvatar';
import {Column} from './../../common/Layouts/Layouts';
import dateFormat from 'dateformat';

const UserReview = ({review}) => {
  const {
    reviewerInfo = {},
    reviewContent = '',
    totalRating = 0,
    images = [],
    hotelReply = {},
    lastName = '',
    firstName = '',
    submittedAt = '',
    image_url = '',
    travellerData = {},
  } = review;
  const {hrc = 0} = reviewerInfo;
  const [showAll, toggleShowAll] = useState(false);
  const [galleryImages, updateGalleryImages] = useState([]);
  const [currentImageIndex, updateCurrentImageIndex] = useState(1);

  const imgReviewData = {
    firstName: firstName,
    lastName: lastName,
    submittedAt: submittedAt,
    reviewContent: reviewContent,
  };

  const {
    isModalOpen: isReviewGalleryModalOpen,
    closeModal: closeReviewGalleryModal,
    openModal: openReviewGalleryModal,
  } = useModal();

  useEffect(() => {
    if (images.length > 0) {
      let galleryImg = [];
      images.map(item => {
        let imgObj = {
          m: item.thumbUrl,
          b: item.bigUrl,
          t: '',
        };
        galleryImg.push(imgObj);
      });
      updateGalleryImages(galleryImg);
    }
  }, [images]);

  const showFullReview = () => {
    toggleShowAll(!showAll);
    pushga({
      eventCategory: DetailPageGAEvents.reviewConsumptionCategory,
      eventAction: DetailPageGAEvents.readMoreReview,
    });
  };

  const getParsedReview = text => {
    let openTag = '<b>',
      closeTag = '</b>';
    const comp = [];
    if (!text || text === null || text === 'null') {
      return null;
    }
    const splitArray = text.split(openTag);
    if (splitArray[0].indexOf(closeTag) === -1) {
      if (splitArray[0]) {
        comp.push(<UserReviewTextStyle>{splitArray[0]}</UserReviewTextStyle>);
      }
      splitArray.shift();
    }

    splitArray.forEach(txt => {
      const secondSplit = txt.split(closeTag);
      if (secondSplit[0]) {
        comp.push(<UserReviewTextStyle className="active">{secondSplit[0]}</UserReviewTextStyle>);
      }
      if (secondSplit[1]) {
        comp.push(<UserReviewTextStyle>{secondSplit[1]}</UserReviewTextStyle>);
      }
    });
    if (!comp.length) {
      return null;
    }
    return <UserReviewTextStyle>{comp}</UserReviewTextStyle>;
  };

  const pushGAForImageClick = () => {
    pushga({
      eventCategory: DetailPageGAEvents.reviewConsumptionCategory,
      eventAction: DetailPageGAEvents.reviewImageClicked,
    });
  };

  return (
    <>
      <WrapperDiv itemScope itemProp="reviews" itemType="http://schema.org/Review">
        <UserAvatarWrapperDiv>
          <UserAvatar userImg={image_url} firstName={firstName} lastName={lastName} />
        </UserAvatarWrapperDiv>

        <UserReviewOuterWrapperDiv>
          <Column>
            <UserDetailsAndRatingWrapperDiv>
              <Column>
                <div>
                  <UserNameStyle itemProp="author">
                    {firstName} {lastName}
                  </UserNameStyle>
                  <StayedOnStyle>(Stayed {dateFormat(submittedAt, 'd mmm, yyyy')})</StayedOnStyle>
                  <meta content={dateFormat(submittedAt, 'yyyy-mm-dd')} itemProp="datePublished" />
                </div>
                <AskedByStyle>
                  {travellerData.text && `${travellerData.text} |`} {hrc}{' '}
                  {hrc > 1 ? 'Reviews Written' : 'Review Written'}
                </AskedByStyle>
              </Column>
              {totalRating > 0 && (
                <Column>
                  <RatingWrapperDiv
                    totalRating={totalRating}
                    itemProp="reviewRating"
                    itemScope
                    itemType="http://schema.org/Rating"
                  >
                    <RatingTextStyle itemProp="ratingValue">{totalRating}</RatingTextStyle>
                    <RatingTextStyle>/5</RatingTextStyle>
                  </RatingWrapperDiv>
                </Column>
              )}
            </UserDetailsAndRatingWrapperDiv>
            {reviewContent && reviewContent.length >= 500 && reviewContent.length <= 600 && (
              <UserReviewWrapperDiv>
                <UserReviewTextStyle itemProp="reviewBody">
                  {getParsedReview(reviewContent)}
                </UserReviewTextStyle>
              </UserReviewWrapperDiv>
            )}
            {reviewContent && !(reviewContent.length >= 500 && reviewContent.length <= 600) && (
              <UserReviewWrapperDiv>
                <UserReviewTextStyle>
                  {showAll
                    ? getParsedReview(reviewContent)
                    : getParsedReview(reviewContent.substring(0, 500))}
                  {(!showAll && reviewContent.length > 500 && (
                    <PrimaryLink onClick={showFullReview}> ...more</PrimaryLink>
                  )) ||
                    ''}
                </UserReviewTextStyle>
              </UserReviewWrapperDiv>
            )}

            {images.length > 0 && (
              <UserReviewImageListWrapperDiv>
                {images.map((data, i) => {
                  return (
                    <>
                      {i <= 6 ? (
                        <RowWithMarginR10 key={`${data.thumbUrl}-${i}`}>
                          <StyledImage
                            src={data.thumbUrl}
                            onClick={() => {
                              updateCurrentImageIndex(i + 1),
                                openReviewGalleryModal(),
                                pushGAForImageClick();
                            }}
                          />
                          {images.length >= 6 && i === 6 ? (
                            <ViewAllWrapDiv
                              onClick={() => {
                                updateCurrentImageIndex(i + 1),
                                  openReviewGalleryModal(),
                                  pushGAForImageClick();
                              }}
                            >
                              <ViewAllText>View All</ViewAllText>
                            </ViewAllWrapDiv>
                          ) : (
                            ''
                          )}
                        </RowWithMarginR10>
                      ) : (
                        ''
                      )}
                    </>
                  );
                })}
              </UserReviewImageListWrapperDiv>
            )}
            <Modal
              isOpen={isReviewGalleryModalOpen}
              closeModal={closeReviewGalleryModal}
              modalStyles={{
                width: '80vw',
              }}
            >
              {galleryImages.length > 0 ? (
                <ImageGalleryPopup
                  styleProps={{width: '80%'}}
                  data={galleryImages}
                  totalCount={images.length}
                  isUserReview={true}
                  tabsRequired={false}
                  initialPage={currentImageIndex}
                  reviewInfo={imgReviewData}
                />
              ) : (
                ''
              )}
            </Modal>

            {hotelReply && hotelReply.designation && (
              <HotelierResponseWrapperDiv>
                <HotelierResponseContentStyle>
                  <HotelierNameTextStyle>
                    {hotelReply.designation} replied {hotelReply.repliedAfter}
                  </HotelierNameTextStyle>
                  <HotelierResponseTextStyle>{hotelReply.response}</HotelierResponseTextStyle>
                </HotelierResponseContentStyle>
              </HotelierResponseWrapperDiv>
            )}
          </Column>
        </UserReviewOuterWrapperDiv>
      </WrapperDiv>
    </>
  );
};

export default UserReview;

const RatingWrapperDiv = styled(Column)(props => {
  return `
    display: inline-block;
    padding: ${props.theme.spacing.small};
    border-radius: ${props.theme.misc.borderRadius.base};
    background-color: ${getRatingsColor(props.totalRating)};
  `;
});
